<template>
  <div class="tableBtn">
    <b-button id="deleteBtn" pill size="sm" @click="onClick"
      ><slot><i class="bi bi-trash-fill icon deleteBtnIcon"></i></slot
    ></b-button>
  </div>
</template>

<script>
export default {
  name: 'DeleteButton',
  methods: {
    onClick() {
      this.$emit('clickEvent')
    }
  }
}
</script>

<style lang="scss" scoped>
$icon-color: white;

.deleteBtnIcon {
  font-size: 16px;
  color: $icon-color;
}
</style>
